import { render } from "./AdminPage.vue?vue&type=template&id=7956fa68&ts=true"
import script from "./AdminPage.ts?vue&type=script&lang=ts"
export * from "./AdminPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__